import { Preload } from 'create-es6-js';
import PreloaderElement from './PreloaderElement';

const preload = {
  DataUtils: Preload.DataUtils,
  DOMUtils: Preload.DOMUtils,
  ElementsUtils: Preload.ElementsUtils,
  RequestUtils: Preload.RequestUtils,
  URLUtils: Preload.URLUtils,
  AbstractLoader: Preload.AbstractLoader,
  AbstractMediaLoader: Preload.AbstractMediaLoader,
  BinaryLoader: Preload.BinaryLoader,
  CSSLoader: Preload.CSSLoader,
  ImageLoader: Preload.ImageLoader,
  JavaScriptLoader: Preload.JavaScriptLoader,
  JSONLoader: Preload.JSONLoader,
  JSONPLoader: Preload.JSONPLoader,
  ManifestLoader: Preload.ManifestLoader,
  SoundLoader: Preload.SoundLoader,
  SpriteSheetLoader: Preload.SpriteSheetLoader,
  SVGLoader: Preload.SVGLoader,
  TextLoader: Preload.TextLoader,
  VideoLoader: Preload.VideoLoader,
  XMLLoader: Preload.XMLLoader,
  AbstractRequest: Preload.AbstractRequest,
  MediaTagRequest: Preload.MediaTagRequest,
  TagRequest: Preload.TagRequest,
  XHRRequest: Preload.XHRRequest,
  SamplePlugin: Preload.SamplePlugin,
  LoadItem: Preload.LoadItem,
  LoadQueue: Preload.LoadQueue,
  Methods: Preload.Methods,
  Types: Preload.Types,
  PreloaderElement,
};

export default preload;




// WEBPACK FOOTER //
// ./Preload/index.js